import styles from "./styles.module.scss";
import Layout from "../../components/Home/layout";
import SecondBlock from "../../components/solutions/secondBlock";
import CardBlock from "../../components/solutions/cardBlock";
import Expertise from "../../components/solutions/expertise";
import { useTitle } from "../../hooks";

const Solutions = () => {
  useTitle("Train GRC | Training, Studio, and Advisory Solutions");

  return (
    <Layout active="solutions">
      <div className={styles.solutions}>
        <SecondBlock />
        <CardBlock />
        <Expertise />
      </div>
    </Layout>
  );
};

export default Solutions;
